import { initContract } from "@ts-rest/core";
import { z } from "zod";
import {
    bulkMarkForDeletionRequestSchema,
    bulkMarkForDeletionResponseSchema,
} from "@common/schemas/delete-transaction.schema";

const c = initContract();

export const deleteTransactionContract = c.router(
    {
        bulkMarkForDeletion: {
            method: "POST",
            path: "/soft/bulk",
            body: bulkMarkForDeletionRequestSchema,
            responses: {
                200: bulkMarkForDeletionResponseSchema,
                400: c.type<{ message: string }>(),
            },
        },
        markForDeletion: {
            method: "DELETE",
            path: "/soft/:transactionId",
            pathParams: z.object({
                transactionId: z.coerce.number(),
            }),
            responses: {
                200: c.type<{ transactionId: number }>(),
                400: c.type<{ message: string }>(),
            },
        },
        cancelDeletion: {
            method: "POST",
            path: "/restore/:transactionId",
            pathParams: z.object({
                transactionId: z.coerce.number(),
            }),
            body: null,
            responses: {
                200: c.type<{ transactionId: number }>(),
                400: c.type<{ message: string }>(),
            },
        },
        finalizeDeletion: {
            method: "DELETE",
            path: "/hard/:transactionId",
            pathParams: z.object({
                transactionId: z.coerce.number(),
            }),
            responses: {
                200: c.type<{ transactionId: number }>(),
                400: c.type<{ message: string }>(),
            },
        },
    },
    {
        pathPrefix: "/delete-transaction",
    },
);
